import { useEffect } from 'react';
import moment from 'moment';
import { setTimeFormat } from '../../../../../util';

export const useAppointmentFormPrefill = ({
  id,
  appointmentData,
  form,
  onCabainChange,
  setDate,
  setStartTime,
}) => {
  useEffect(() => {
    if (id) return;
    if (!appointmentData?.cabainId) return;

    const [time] = appointmentData?.time.split(' ');

    form.setFieldsValue({
      branchId: appointmentData?.branchId,
      cabainId: appointmentData?.cabainId,
      startTime: setTimeFormat(time),
      date: moment(appointmentData?.date),
    });

    setDate(appointmentData?.date);
    setStartTime(time);

    onCabainChange(appointmentData?.cabainId);
  }, [appointmentData?.cabainId, appointmentData?.date, id]);
};
